{
  "de": {
    "pupilFeedback": {
      "deprecationAlert": {
        "title": "Dieses Tool ist standardmäßig ausgeblendet",
        "description": "Es kann auf Wunsch auf Schulebene freigeschaltet werden.",
        "learnMoreLink": "Mehr erfahren"
      },
      "unlockedAlert": {
        "title": "Dieses Tool ist für deine Schule freigeschaltet",
        "description": "Es wird nicht weiterentwickelt, bleibt für deine Schule aber nutzbar.",
        "learnMoreLink": "Mehr erfahren"
      },
      "alerts": {
        "example": "Wie kann das aussehen?",
        "exampleButton": "Beispiel für Aufgabe und Kriterien einfügen",
        "noFeedbackYet": "Es konnte kein Feedback generiert werden. Bitte überprüfe deine Eingaben und versuche es erneut.",
        "pupilFeedback": "<strong>Hinweis:</strong> Das Feedback ist von einer KI auf Basis der vorgegebenen Kriterien automatisch generiert und kann Fehler beinhalten. Bei Fragen oder Unklarheiten wende dich an deine Lehrkraft.",
        "pupilFeedbackStudent": "<strong>Hinweis:</strong> Das Feedback wird mithilfe von KI erstellt und basiert auf den Aufgaben, Materialien und Kriterien, die von deiner Lehrkraft festgelegt wurden. Bei Fragen oder Unklarheiten wende dich bitte an deine Lehrkraft.",
        "submitting": "Dein Feedback wird gerade erstellt. ",
        "submittingDescription": "Bitte warte einen Moment."
      },
      "example": {
        "criteriaAttributes": {
          "0": "Die Geschichte folgt einer logischen Erzählstruktur und hat einen Titel, eine Einleitung, einen Mittelteil und einen Schluss. Die Ereignisse bauen aufeinander auf und führen zu einem kurzen Ende, wobei der Titel zum Thema der Geschichte passt.",
          "1": "Die Geschichte nutzt sprachliche Mittel, um spannend zu sein. Du benutzt beschreibende Wörter (wie 'gruselig', 'unheimlich', 'dunkel'), und beschreibst genau, was die Personen sehen, hören und fühlen.",
          "2": "Die Grammatik und Rechtschreibung der Geschichte sind korrekt. Du achtest auf richtige Satzstrukturen, korrekte Zeitformen und Rechtschreibung, sodass der Text flüssig zu lesen.",
          "3": "Die Geschichte enthält abwechslungsreiche Satzanfänge."
        },
        "description": "Lies den Zeitungsartikel “Nacht im Moor”. Schreibe eine Gruselgeschichte auf der Grundlage der Geschehnisse. Achte dabei auf die Gestaltungskriterien, um deine Geschichte möglichst spannend zu machen.",
        "material": "<strong>Zeitungsartikel</strong><br>CARLSFELD. Eine schaurige Nacht in einem Moor bei Carlsfeld musste ein Vater mit seinen Kindern durchleben. Nach einer Fahrradpanne versuchte Herr T. mit Maria (12) und Tom (10) zu Fuß heimzukommen. Bei Frost und Nebel verirrten sie sich jedoch im Moor. Eine groß angelegte Suchaktion der Polizei, die die besorgte Mutter auslöste, brachte erst am Morgen Erfolg: Spürhunde der Polizei fanden die drei völlig durchgefroren.",
        "name": "Gruselgeschichte"
      },
      "flash": {
        "textExtractionSuccess": "Textextraktion erfolgreich"
      },
      "headings": {
        "criteria": "Kriterium",
        "form": "Aufgabe und Kriterien festlegen"
      },
      "hints": {
        "experimental": "Das Feedback für Schüler*innen Tool erstellt <strong>KI-generiertes Feedback</strong> auf Basis der von Lehrkräften hinterlegten Aufgabe, Materialien und Kriterien. Um das Feedback verantwortungsvoll zu interpretieren, müssen die empfohlenen <strong>Rahmenbedingungen und Einschränkungen der KI</strong> unbedingt zur Kenntnis genommen und beachtet werden. <a href='https://app.fobizz.com/de/help/articles/251-feedback-tool-ki' target='_blank'>Mehr erfahren</a>",
        "noSubmission": "Noch nicht abgegeben",
        "submitSuccessful": "Vielen Dank! Du hast dein Aufgabe erfolgreich abgegeben.",
        "submitSuccessfulShort": "Aufgabe erfolgreich übermittelt"
      },
      "infoMessages": {
        "criteria": "Lege Kriterien fest, auf deren Grundlage die KI Feedback geben soll. Je genauer du die Kriterien formulierst, desto präziser ist das Feedback.",
        "criterion": "Mindestens ein Kriterium notwendig"
      },
      "labels": {
        "allResponses": "Alle Antworten",
        "answer": "Antwort",
        "assignment": "Arbeitsauftrag",
        "assignmentTitle": "Aufgabentitel",
        "averageScore": "Gesamtbewertung:",
        "criteria": "Feedbackkriterien",
        "criteriaVisibleForPupils": "Sichtbar für Schüler*innen",
        "difference": "Unterschiede zur 1. Version",
        "draftsAndSubmissions": "Entwürfe und Abgaben",
        "editFeedback": "Antwort bearbeiten",
        "emptySubmission": {
          "description": "Teile die Aufgabe mit deinen Schüler*innen. Sobald sie ihr erstes Feedback einholen, siehst du hier den Fortschritt.",
          "title": "Für diese Aufgabe sind noch keine Entwürfe oder Abgaben vorhanden."
        },
        "feedback": "Feedback",
        "finalSubmission": "Abgabe | Abgaben",
        "finalSubmit": "Aufgabe abgeben",
        "firstSubmission": "1. Version | 1. Versionen",
        "material": "Material",
        "materialVisibleForPupils": "Sichtbar für Schüler*innen",
        "noScoreYet": "Bewertung noch offen",
        "of": "von {count}",
        "score": "Bewertung",
        "submit": "Gib mir Feedback"
      },
      "links": {
        "imageRecognition": "Text aus Bild verwenden",
        "textExtraction": "Text aus PDF verwenden",
        "toggleFeedbackDetails": "Feedback anzeigen"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/251-feedback-tool-ki",
          "text": "Das Feedback für Schüler*innen Tool erstellt KI-generiertes Feedback auf Basis der von Lehrkräften hinterlegten Aufgabe, Materialien und Kriterien. Um das Feedback verantwortungsvoll zu interpretieren, müssen die empfohlenen Rahmenbedingungen und Einschränkungen der KI unbedingt zur Kenntnis genommen und beachtet werden.",
          "title": "Hinweise zur Nutzung der Feedback Tools"
        }
      },
      "placeholders": {
        "answer": "Gib deine Antwort hier ein...",
        "assignment": "Arbeitsauftrag hier eingeben...",
        "assignmentTitle": "Name für Aufgabe eingeben...",
        "criterion": "Kriterium eingeben...",
        "language": "Sprache für das KI Feedback",
        "material": "Füge Hilfestellungen oder Zusatzmaterial für die Bearbeitung der Aufgabe hier ein."
      },
      "responseItem": {
        "confirmDelete": {
          "confirm": "Löschen",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Die Antwort wird dauerhaft gelöscht.",
          "title": "Antwort löschen?"
        },
        "delete": "Antwort löschen",
        "firstFeedback": "1. Version",
        "share": "Zugangslink kopieren",
        "submission": "Abgabe"
      },
      "simpleLanguage": {
        "loading": "Bitte warten...",
        "translate": "Feedback in leichter Sprache anzeigen"
      }
    },
    "pupil_feedback": {
      "anonymous": "Anonym"
    }
  }
}
